module.exports = __webpack_public_path__ + "files/e1341cc053c422c1844a0bf7a0ffa36a.png";